module.exports = __webpack_public_path__ + "img/wechat.96e483f0.jpg";